 function clickImgHrefMobile(event,url){
        window.location.href = url;
    }



    var dragImageListSwiper = new Swiper("#dragImageListSwiperDiv-mobile", {
        slidesPerView: 'auto',
        preventClicks:'false',
        spaceBetween: 8,
        slidesOffsetBefore: 4,
        touchRatio:1.5,
        breakpoints: {
            1024: {  //当屏幕宽度大于等于1024
                slidesPerView: 'auto',
                spaceBetween: 16,
                loop:true
            }
        }
    });

    function previousMobileDragImageArrowClick() {
        dragImageListSwiper.slidePrev();
    }

    function nextMobileDragImageArrowClick() {
        dragImageListSwiper.slideNext();
    }

    /*=================== 拖拽 =================== */
    // var dragImageBlockMobileMoveDiv = $('.dragImageListMoveDiv-mobile');
    // var animateFlag = false;
    // var dragImageBlockMobileIsKeyDown = false;
    // var dragImageBlockMobileIsMove = false;
    // var dragImageBlockMobileMoveX = 0;
    // var dragImageBlockMobileCurrentX;
    // var dragImageBlockMobileTriggerCurrentX;
    // var dragImageBlockMobileTriggerMoveX;
    // var dragImageBlockMobileClickHref;
    // var clickUrlMobile;
    // var dragImageBlockMobileIndex = 1;
    // var dragImageBlockMobileWidth = $(".dragImageProductBlock-mobile").outerWidth(true);
    // var dragImageBlockMobileCount = $(".dragImageProductBlock-mobile").length;
    // var maxCount = parseInt(window.screen.width / dragImageBlockMobileWidth);
    // var maxLeft =((dragImageBlockMobileWidth + 8) * dragImageBlockMobileCount - 8 + 80) - window.screen.width;
    //
    //
    // // 监听按下
    // dragImageBlockMobileMoveDiv.on('touchstart mousedown',function (e) {
    //
    //     dragImageBlockMobileIsKeyDown = true;
    //     if (e.type === 'mousedown'){
    //         dragImageBlockMobileCurrentX = e.clientX;
    //         dragImageBlockMobileTriggerCurrentX = e.clientX;
    //     }else if (e.type === 'touchstart'){
    //         dragImageBlockMobileCurrentX = e.originalEvent.changedTouches[0].clientX;
    //         dragImageBlockMobileTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
    //     }
    //
    // });
    // function clickImgHrefMobile(event,url){
    //     clickUrlMobile = url;
    //
    //     dragImageBlockMobileIsKeyDown = true;
    //     if (event.type === 'mousedown'){
    //         dragImageBlockMobileCurrentX = event.clientX;
    //         dragImageBlockMobileTriggerCurrentX = event.clientX;
    //     }else if (event.type === 'touchstart'){
    //         dragImageBlockMobileCurrentX = event.originalEvent.changedTouches[0].clientX;
    //         dragImageBlockMobileTriggerCurrentX = event.originalEvent.changedTouches[0].clientX;
    //
    //     }
    // }
    //
    // // 监听鼠标移动事件
    // dragImageBlockMobileMoveDiv.on('touchmove mousemove',function (e) {
    //     if (dragImageBlockMobileIsKeyDown) {
    //         // 计算移动距离
    //         if (e.type === 'mousemove'){
    //             dragImageBlockMobileMoveX = parseInt(e.clientX) -  parseInt(dragImageBlockMobileCurrentX);
    //             dragImageBlockMobileTriggerMoveX =  parseInt(e.clientX) -  parseInt(dragImageBlockMobileTriggerCurrentX);
    //             // 重要！ 准确记录每次触发的移动量
    //             dragImageBlockMobileTriggerCurrentX = e.clientX;
    //         }else if (e.type === 'touchmove'){
    //             dragImageBlockMobileMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(dragImageBlockMobileCurrentX);
    //             dragImageBlockMobileTriggerMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(dragImageBlockMobileTriggerCurrentX);
    //             // 重要！ 准确记录每次触发的移动量
    //             dragImageBlockMobileTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
    //         }
    //         if (dragImageBlockMobileMoveX === 0 || dragImageBlockMobileTriggerMoveX === 0) {
    //             return;
    //         }
    //         if (dragImageBlockMobileMoveX > 0){
    //             dragImageBlockMobileMoveDiv.stop().animate({left: "+=" + dragImageBlockMobileTriggerMoveX * 1.15  + "px"}, 0, function() {
    //             });
    //         }else if(dragImageBlockMobileMoveX < 0){
    //             dragImageBlockMobileMoveDiv.stop().animate({left: "+=" + dragImageBlockMobileTriggerMoveX * 1.15 + "px"}, 0, function() {
    //             });
    //         }
    //         if ()
    //         dragImageBlockMobileIsMove = true;
    //     }
    //
    //
    //
    // })
    //
    // // 监听抬起
    // dragImageBlockMobileMoveDiv.on('touchend mouseup',function (e) {
    //     if (dragImageBlockMobileIsKeyDown){
    //
    //         dragImageBlockMobileIsKeyDown = false;
    //         dragImageBlockMobileIsMove = false;
    //
    //         if (dragImageBlockMobileMoveX === 0 && clickUrlMobile != null && clickUrlMobile.toString() != 'undefined') {
    //             window.location.href = clickUrlMobile;
    //             return;
    //         }
    //
    //
    //
    //         dragImageBlockMobileMoveX = dragImageBlockMobileMoveX * 1.15;
    //
    //
    //         // 超出的距离（余数）
    //         var moveCount =Math.round(Math.abs(parseInt(dragImageBlockMobileMoveX)) / parseInt(dragImageBlockMobileWidth));
    //
    //         var overX =Math.abs(parseInt(dragImageBlockMobileMoveX)) % parseInt(dragImageBlockMobileWidth);
    //         var currentLeft = dragImageBlockMobileMoveDiv.css('left');
    //
    //         if (overX > (dragImageBlockMobileWidth / 2) && parseInt(currentLeft) <= 0){
    //
    //
    //             if ((parseInt(currentLeft) + dragImageBlockMobileMoveX + overX ) * -1 > maxLeft){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: maxLeft * -1 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * dragImageBlockMobileWidth) ) >= 0 && dragImageBlockMobileMoveX > 0){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * dragImageBlockMobileWidth  * -1)) >= 0 && dragImageBlockMobileMoveX < 0){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else {
    //                 if (dragImageBlockMobileMoveX > 0){
    //
    //                     dragImageBlockMobileMoveDiv.stop().animate({left: (dragImageBlockMobileIndex - moveCount - 1) * dragImageBlockMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }else {
    //                     dragImageBlockMobileMoveDiv.stop().animate({left: (dragImageBlockMobileIndex + moveCount  - 1 ) * dragImageBlockMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }
    //
    //             }
    //
    //         }else if (parseInt(currentLeft) <= 0){
    //             // 反之
    //             if ((parseInt(currentLeft) + dragImageBlockMobileMoveX ) * -1 > maxLeft){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: maxLeft  * -1 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * dragImageBlockMobileWidth * -1) ) >= 0 && dragImageBlockMobileMoveX > 0){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else if ((parseInt(currentLeft) + (moveCount * dragImageBlockMobileWidth ) ) >= 0 && dragImageBlockMobileMoveX < 0){
    //                 dragImageBlockMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                     animateFlag = false;
    //                 });
    //             }else{
    //                 if (dragImageBlockMobileMoveX > 0){
    //
    //                     dragImageBlockMobileMoveDiv.stop().animate({left: (dragImageBlockMobileIndex - moveCount - 1) * dragImageBlockMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //
    //                 }else{
    //
    //                     dragImageBlockMobileMoveDiv.stop().animate({left: (dragImageBlockMobileIndex + moveCount - 1 ) * dragImageBlockMobileWidth * -1 + 'px' }, 300, function() {
    //                         animateFlag = false;
    //                     });
    //                 }
    //             }
    //
    //         }else {
    //             dragImageBlockMobileMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
    //                 animateFlag = false;
    //             });
    //         }
    //
    //         sleep(350).then(() => {
    //
    //             dragImageBlockMobileIndex = Math.floor(parseInt(dragImageBlockMobileMoveDiv.css('left')) * -1 / parseInt(dragImageBlockMobileWidth) + 1);
    //         })
    //
    //         // 重置位移数，防止连点移动
    //         dragImageBlockMobileMoveX = 0;
    //
    //     }
    //     else if (productHistoricalRecordIsKeyDown) {
    //         if (dragImageBlockMobileMoveX === 0 && clickUrlMobile != null && clickUrlMobile.toString() != 'undefined') {
    //             window.location.href = clickUrlMobile;
    //         }
    //     }
    //
    // });